<template>
  <div>
    מעבירים אותך להרשמה ליעוץ אישי...
  </div>
</template>

<script>
export default {
  name: 'CounselingSignup',
  data() {
    return {
    };
  },
  mounted() {
    // extract parameters from last folder in url
    const urlParams = this.$route.params.details.split('---');

    const cardcomLinkPrefix = "https://secure.cardcom.solutions/e/5FToqjwy5Uy3eITDtONi1w";

    // split url params by ---


    const cardcomLinkParams = {
      "subscribers_phone": urlParams[0],
      "subscribers_email": urlParams[1],
      "subscribers_name": urlParams[2],
      "custom_field_01": urlParams[2]
    }

    // redirect to cardcom
    window.location.href = `${cardcomLinkPrefix}?${new URLSearchParams(cardcomLinkParams).toString()}`;
  }
};
</script>